/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostTagSortCriteria {
    getFixupPrototypeFunction() { return CostTagSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<CostTagSortCriteria>): CostTagSortCriteria {
        let obj = Object.assign(new CostTagSortCriteria(), model);
        CostTagSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostTagSortCriteria>): CostTagSortCriteria {
        if (!model) return null;
        return CostTagSortCriteria.newInstance(<CostTagSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostTagSortCriteria) {
        if (!obj) return;

        models.CostTagSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostTagSortCriteria): boolean {
        Object.setPrototypeOf(obj, CostTagSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.CostTagSortColumn;

    ascending: boolean;

}
